<template>
  <b-modal size="lg"
           v-model="showModal"
           @ok="submitForm"
           :ok-disabled="isAdding">
    <div slot="modal-title">
      {{ $t(modalTitle) }}
    </div>
    <section>
      <company-address-form ref="companyAddressForm" @finished="onFinish"/>
    </section>
    <div slot="modal-cancel" @click="showModal = false">{{ $t('message.button.close') }}</div>
    <div slot="modal-ok">{{ isAdding ? $t('message.button.loading') : $t('message.button.save') }}</div>
  </b-modal>
</template>

<script>
  import { mapState } from 'vuex'
  import CompanyAddressForm from '../../booking/components/CompanyAddressForm'

  export default {
    props: {
      manageData: Boolean,
      formAction: String
    },
    name: 'ModalCompanyAddress',
    components: {
      CompanyAddressForm
    },
    data () {
      return {
        showModal: false
      }
    },
    computed: {
      ...mapState('companyAddress', [
        'isAdding'
      ]),
      modalTitle () {
        return (this.formAction === 'add') ? 'message.company_address.add_new_company_address' : 'message.company_address.edit_company_address'
      }
    },
    methods: {
      onFinish () {
        this.showUserCompanyModal(false)
        this.$emit('finished', true)
      },
      showUserCompanyModal (status) {
        this.showModal = status
      },
      clearFormData () {
        if (this.$refs.companyAddressForm) {
          this.$refs.companyAddressForm.setEmptyForm()
        }
      },
      setUserAddressData (index) {
        if (this.$refs.companyAddressForm) {
          this.$refs.companyAddressForm.setUserAddressData(index)
        }
      },
      submitForm (evt) {
        // Prevent modal from closing
        evt.preventDefault()
        if (this.$refs.companyAddressForm) {
          this.$refs.companyAddressForm.submitFormAddress('company-address', this.formAction)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/companyAddress/CompanyAddressModal.vue